import React, { useState } from "react";
import { allSharedComponents } from "../../../shared";
import { Col, Row, Button } from "react-bootstrap";
import { t } from "i18next";
import { translationConstants } from "../../../constants";
import CustomModal from "../../../shared/components/CustomModal/CustomModal";
import AddQualification from "../../../shared/components/Modals/AddQualification";
const BecomeCertifiedPractitioner = (props) => {
  const {
    CertifiedPractitionerHeading,
    BaseBecomeCertifiedPractitioner,
    SportType,
  } = allSharedComponents;

  const [showAddQualificationModal, setAddQualificationModal] = useState(false);

  return (
    <div className="BecomeVerifiedUserContainer">
      <BaseBecomeCertifiedPractitioner {...props}>
        <CertifiedPractitionerHeading isInstructor={props?.isInstructor} />
        <SportType
          isShowAddButton={true}
          setAddQualificationModal={setAddQualificationModal}
        />
        <Row className="mt-4 d-flex justify-content-center">
          <Col sm={12} lg={6} className="d-flex justify-content-center">
            <Button className="btn-submit mb-2" type="submit">
              {t(translationConstants.submit)}
            </Button>
          </Col>
          <Col sm={12} lg={6} className="d-flex justify-content-center">
            <Button
              className="reject-button m-0"
              onClick={() => {
                props?.onSetShow();
              }}
            >
              {t(translationConstants.CANCEL)}
            </Button>
          </Col>
        </Row>
      </BaseBecomeCertifiedPractitioner>

      {showAddQualificationModal && (
        <CustomModal
          size={"lg"}
          scrollable={true}
          customClass="view-user-modal"
          show={showAddQualificationModal}
          setShow={setAddQualificationModal}
        >
          <AddQualification
            setAddQualificationModal={setAddQualificationModal}
            isInstructor={props?.isInstructor}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default BecomeCertifiedPractitioner;
